<script>
import Vue from "vue";
import { ContainerType, ContainerAction } from "@/helpers";
import OrderCreate from "./OrderCreate.vue";

export default Vue.extend({
  props: {
    agreement: Object,
  },
  data: () => {
    return {
      showMobileOrderDialog: false,
      showDesktopOrderDialog: false,
      containerActions: [{}],
      actionLabels: [],
      openOrderCount: 0,
      dialogKey: 0,
    };
  },
  components: {
    OrderCreate,
  },
  watch: {
    showMobileOrderDialog(value) {
      if (value !== true) {
        this.dialogKey += 1;
      }
    },
    showDesktopOrderDialog(value) {
      if (value !== true) {
        this.dialogKey += 1;
      }
    },
  },
  computed: {
    containerName() {
      if (this.agreement.containerTypeId === ContainerType.LOSE_ABHOLUNG
        || ContainerType.BIGBAG.includes(this.agreement.containerTypeId)
        || ContainerType.SAMMELSACK.includes(this.agreement.containerTypeId)) {
        return this.agreement.containerType.type
          + (this.agreement.containerType.extra ? ` ${this.agreement.containerType.extra}` : '')
          + (this.agreement.containerType.size ? `, ${this.agreement.containerType.size}` : '')
      }
      return String.prototype.concat(
        this.agreement.amount,
        "x",
        " ",
        this.agreement.containerType.type,
        (this.agreement.containerType.extra ? ` ${this.agreement.containerType.extra}` : ''),
        ", ",
        this.agreement.containerType.size || ""
      );
    },
    additionalAgreementInfo() {
      if (this.agreement.agreementTypeId === 4) {
        let secondDay = "";
        if (this.agreement.selectedSecondDay) {
          secondDay = this.agreement.selectedSecondDay !== 'Egal' ? " & " + this.agreement.selectedSecondDay?.slice(0, 2) : (this.agreement.selectedFirstDay !== 'Egal' ? " & " + this.agreement.selectedSecondDay : '');
        }
        const firstDay = this.agreement.selectedFirstDay !== 'Egal' ? ', '+this.agreement.selectedFirstDay?.slice(0, 2) : (this.agreement.selectedSecondDay && this.agreement.selectedSecondDay !== 'Egal'? ', '+this.agreement.selectedFirstDay : '');
        return String.prototype.concat(
          ", ",
          this.agreement.selectedInterval || "",
          firstDay,
          secondDay
        );
      }
      return "";
    },
    isMobile() {
      return this.$vuetify.breakpoint.width < 768;
    },
    agreementTypeLabel() {
      switch (this.agreement.agreementTypeId) {
        case 2: // Sofortbefüllung Type
          return "Sofortbefüllung";
        case 3: // Abruf Type
          return "Dauerauftrag a. Abruf";
        case 4: // Turnus Type
          return "Turnus";
        default:
          return "#Abruf";
      }
    },
    currentOrders() {
      let stellenOrder = 0,
        tauschenOrder = 0,
        abziehenOrder = 0,
        abholenOrder = 0,
        leerenOrder = 0,
        kaufenOrder = 0,
        sofortOrder = 0,
        noOrder = true,
        stellenClaim = false,
        tauschenClaim = false,
        abziehenClaim = false,
        abholenClaim = false,
        leerenClaim = false,
        kaufenClaim = false,
        sofortClaim = false;
      for (const order of this.agreement.orders) {
        switch (order.containerAction.id) {
          case 1:
            {
              abholenOrder += 1;
              noOrder = false;
              if (order.claims && order.claims.length > 0) {
                abholenClaim = true;
              }
            }
            break;
          case 2:
            {
              tauschenOrder += 1;
              noOrder = false;
              if (order.claims && order.claims.length > 0) {
                tauschenClaim = true;
              }
            }
            break;
          case 3:
            {
              abziehenOrder += 1;
              noOrder = false;
              if (order.claims && order.claims.length > 0) {
                abziehenClaim = true;
              }
            }
            break;
          case 4:
            {
              leerenOrder += 1;
              noOrder = false;
              if (order.claims && order.claims.length > 0) {
                leerenClaim = true;
              }
            }
            break;
          case 5:
            {
              stellenOrder += 1;
              noOrder = false;
              if (order.claims && order.claims.length > 0) {
                stellenClaim = true;
              }
            }
            break;
          case 6:
            {
              kaufenOrder += 1;
              noOrder = false;
              if (order.claims && order.claims.length > 0) {
                kaufenClaim = true;
              }
            }
            break;
          case 7:
            {
              sofortOrder += 1;
              noOrder = false;
              if (order.claims && order.claims.length > 0) {
                sofortClaim = true;
              }
            }
            break;
        }
      }
      const currentOrderObject = {
        abholen: { amount: abholenOrder, claimed: abholenClaim },
        tauschen: { amount: tauschenOrder, claimed: tauschenClaim },
        abziehen: { amount: abziehenOrder, claimed: abziehenClaim },
        leeren: { amount: leerenOrder, claimed: leerenClaim },
        stellen: { amount: stellenOrder, claimed: stellenClaim },
        kaufen: { amount: kaufenOrder, claimed: kaufenClaim },
        sofort: { amount: sofortOrder, claimed: sofortClaim },
        empty: noOrder,
      };
      return currentOrderObject;
    },
  },
  methods: {
    closeAllDialog() {
      this.showMobileOrderDialog = false;
      this.showDesktopOrderDialog = false;
    },
    createNewOrder() {
      if (this.$store.getters.userIsOrderManager) {
        let count = 0;
        this.agreement.orders.forEach((element) => {
          count += element.amount;
        });
        this.openOrderCount = count;

        const actions = [];
        const actionLabels = [];
        const ctype = this.agreement.containerType;
        // when own container only Tauschen is possible
        if(this.agreement.ownContainer) {
          actions.push({
            value: ContainerAction.TAUSCHEN,
            text: "Tauschen",
          });
          actionLabels[2] = "Tauschen";
        } else {
          if (ctype.containerAction1) {
            actions.push({
              value: ctype.containerAction1.id,
              text: ctype.containerAction1.description,
            });
            actionLabels[ctype.containerAction1.id] = ctype.containerAction1.description;
          }
          if (ctype.containerAction2) {
            actions.push({
              value: ctype.containerAction2.id,
              text: ctype.containerAction2.description,
            });
            actionLabels[ctype.containerAction2.id] = ctype.containerAction2.description;
          }
        }
        
        this.actionLabels = actionLabels;
        this.containerActions = actions;
        if (this.isMobile) {
          this.showMobileOrderDialog = true;
        } else {
          this.showDesktopOrderDialog = true;
        }
      } else {
        this.$toast.error(
          "Sie haben nicht die Berechtigung, einen Auftrag zu erstellen!"
        );
      }
    },
  },
});
</script>
<template>
  <div style="min-width: 100% !important">
    <v-card
      style="width: 100% !important; max-width: 100% !important"
      @click="createNewOrder"
      :class="isMobile ? 'rounded-lg mobile-individual-card' : 'rounded-lg'"
    >
      <v-card-title
        v-if="!isMobile"
        :style="`background-image: url('${agreement.wasteType.imageLarge}'); background-size: cover`"
        class="independent-vcard"
      ></v-card-title>
      <v-card-text class="independent-vcard">
        <div :class="{ mobile: isMobile }">
          <div v-if="isMobile">
            <v-col cols="11" style="display: inline-flex" class="py-0 px-0">
              <v-avatar
                style="
                  min-width: 20px;
                  height: auto;
                  width: 36px !important;
                  margin-right: 8px;
                "
              >
                <v-img :src="agreement.wasteType.imageSmall" />
              </v-avatar>
              <div style="display: block; max-width: 90%;" class="pl-2">
                <h3
                  class="mt-1"
                  style="
                    font-size: 0.9rem;
                    font-weight: bold;
                    height: 40%;
                    color: black !important;
                    overflow: hidden; white-space: nowrap;
                    text-overflow: ellipsis
                  "
                >
                  {{
                    agreement.wasteType.description
                  }}
                </h3>
                <div style="font-size: 0.8rem; height: 50%">{{ containerName }}</div>
              </div>
            </v-col>
            <v-col
              cols="1"
              style="
                display: inline-flex;
                justify-content: end;
                vertical-align: super;
                margin-left: 5px !important;
              "
              class="py-0 px-0"
            >
              <v-icon
                style="color: rgba(0, 0, 0, 0.6) !important; font-size: 5vw !important"
                >mdi-chevron-right</v-icon
              ></v-col
            >
          </div>
          <div v-if="!isMobile" class="mb-1">
            <h3 class="mt-1" style="color: black !important; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
              {{
                agreement.wasteType.description
              }}
            </h3>
            {{ containerName }}
          </div>
          <v-divider class="mobile-card-divider" />
          <div>
            <v-col
              cols="2"
              style="display: inline-flex; width: 36px !important"
              class="py-1 px-0 mr-2"
            >
              <h3
                class="mt-1"
                style="
                  font-size: 0.8rem;
                  font-weight: bold;
                  height: 50%;
                  color: black !important;
                "
              >
                Art:
              </h3>
            </v-col>
            <v-col
              cols="10"
              style="
                display: inline-flex;
                justify-content: start;
                font-size: 0.8rem;
                padding-left: 8px !important;
                overflow: auto;
              "
              class="py-0 px-0 pl-2"
            >
              {{ agreementTypeLabel + additionalAgreementInfo }}
            </v-col>
          </div>
          <v-divider class="mobile-card-divider" />
          <v-col
            cols="2"
            style="display: inline-flex; width: 36px !important"
            class="py-1 px-0 mr-2"
          >
            <h3
              class="mt-1"
              style="
                font-size: 0.8rem;
                font-weight: bold;
                height: 50%;
                color: black !important;
              "
            >
              Offen:
            </h3>
          </v-col>
          <v-col
            cols="10"
            style="display: inline-flex; font-size: 0.8rem; padding-left: 8px !important"
            class="py-0 px-0 pl-2"
            v-if="currentOrders.empty !== true"
          >
            <div
              style="width: 32%; display: inline-flex; font-size: 0.8rem"
              v-if="currentOrders.abholen.amount > 0"
            >
              <div style="font-weight: bold">{{ currentOrders.abholen.amount }}</div>
              <pre style="font-family: 'Roboto', sans-serif"> Abholen</pre>
              <v-icon
                v-if="currentOrders.abholen.claimed !== false"
                style="color: #f9c07f !important; font-size: 0.8rem !important"
                >mdi-alert</v-icon
              >
            </div>
            <div
              style="width: 35%; display: inline-flex; font-size: 0.8rem"
              v-if="currentOrders.tauschen.amount > 0"
            >
              <div style="font-weight: bold">{{ currentOrders.tauschen.amount }}</div>
              <pre style="font-family: 'Roboto', sans-serif"> Tauschen</pre>
              <v-icon
                v-if="currentOrders.tauschen.claimed !== false"
                style="color: #f9c07f !important; font-size: 0.8rem !important"
                >mdi-alert</v-icon
              >
            </div>
            <div
              style="width: 32%; display: inline-flex; font-size: 0.8rem"
              v-if="currentOrders.abziehen.amount > 0"
            >
              <div style="font-weight: bold">{{ currentOrders.abziehen.amount }}</div>
              <pre style="font-family: 'Roboto', sans-serif"> Abziehen</pre>
              <v-icon
                v-if="currentOrders.abziehen.claimed !== false"
                style="color: #f9c07f !important; font-size: 0.8rem !important"
                >mdi-alert</v-icon
              >
            </div>
            <div
              style="width: 32%; display: inline-flex; font-size: 0.8rem"
              v-if="currentOrders.leeren.amount > 0"
            >
              <div style="font-weight: bold">{{ currentOrders.leeren.amount }}</div>
              <pre style="font-family: 'Roboto', sans-serif"> Leeren</pre>
              <v-icon
                v-if="currentOrders.leeren.claimed !== false"
                style="color: #f9c07f !important; font-size: 0.8rem !important"
                >mdi-alert</v-icon
              >
            </div>
            <div
              style="width: 32%; display: inline-flex; font-size: 0.8rem"
              v-if="currentOrders.stellen.amount > 0"
              :class="
                agreement.agreementTypeId === 2 ? 'order-info-immediate-filling' : ''
              "
            >
              <div style="font-weight: bold">{{ currentOrders.stellen.amount }}</div>
              <pre style="font-family: 'Roboto', sans-serif">
  {{ agreement.agreementTypeId === 2 ? " Sofortbefüllung" : " Stellen" }}</pre
              >
            </div>
            <div
              style="width: 32%; display: inline-flex; font-size: 0.8rem"
              v-if="currentOrders.sofort.amount > 0"
              class="order-info-immediate-filling"
            >
              <div style="font-weight: bold">{{ currentOrders.sofort.amount }}</div>
              <pre style="font-family: 'Roboto', sans-serif"> Sofortbefüllung</pre>
              <v-icon
                v-if="currentOrders.stellen.claimed !== false"
                style="color: #f9c07f !important; font-size: 0.8rem !important"
                >mdi-alert</v-icon
              >
            </div>
            <div
              style="width: 32%; display: inline-flex; font-size: 0.8rem"
              v-if="currentOrders.kaufen.amount > 0"
            >
              <div style="font-weight: bold">{{ currentOrders.kaufen.amount }}</div>
              <pre style="font-family: 'Roboto', sans-serif"> Kaufen</pre>
              <v-icon
                v-if="currentOrders.kaufen.claimed !== false"
                style="color: #f9c07f !important; font-size: 0.8rem !important"
                >mdi-alert</v-icon
              >
            </div>
          </v-col>
          <v-col
            cols="10"
            style="
              display: inline-flex;
              justify-content: start;
              font-size: 0.8rem;
              padding-left: 8px !important;
              overflow: auto;
            "
            class="py-0 px-0 pl-2"
            v-if="currentOrders.empty === true"
          >
            -
          </v-col>
        </div>
      </v-card-text>
    </v-card>
    <v-bottom-sheet v-model="showMobileOrderDialog" max-width="500" v-if="isMobile">
      <order-create
        :agreement="agreement"
        :containerActions="containerActions"
        :actionLabels="actionLabels"
        :openOrderCount="openOrderCount"
        :key="dialogKey"
        @close-beauftragen-dialog="closeAllDialog"
      />
    </v-bottom-sheet>
    <v-dialog v-model="showDesktopOrderDialog" max-width="500" v-if="!isMobile" persistent>
      <order-create
        :agreement="agreement"
        :containerActions="containerActions"
        :actionLabels="actionLabels"
        :openOrderCount="openOrderCount"
        :key="dialogKey"
        @close-beauftragen-dialog="closeAllDialog"
      />
    </v-dialog>
  </div>
</template>
<style lang="sass" scoped>
.v-card--link
  &:hover
    box-shadow: 0px 0px 6px 6px rgba(0, 0, 0, 0.1) !important

.mobile-individual-card
  margin-bottom: 2px
.independent-vcard.v-card__title
  height:90px
.independent-vcard .v-card__subtitle
  background-color: rgba(255,255,255,.8)
  color: #000 !important
  margin:0
  margin-top:0px
  padding-bottom:0

.independent-vcard.v-card__text
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis

.independent-vcard
  padding-top: 10px !important
  padding-bottom: 6px !important
ul
  padding: 0
  margin: 0
  li
    list-style-type: none
.order-info-immediate-filling
  width: 48% !important
</style>
